import type { FC } from 'react';
import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import Button from '@trend-dev/trendtech-ui/components/UI/Button';

import { Paper, Subtitle, Title, Wrapper } from 'components/UI/Paper';

import { useDeviceWidth } from 'hooks/useDeviceWidth';

import { searchParamsNames } from 'constants/searchParamsNames';

import { buttonText, subtitle, title } from './const';
import { useSendFeedback } from './hooks/useSendFeedback';
import styles from './styles.module.scss';

const Exit: FC = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const redirectTo = searchParams.get(searchParamsNames.redirectTo);
    const { isDesktop } = useDeviceWidth();

    useSendFeedback();

    const handleClick = useCallback(() => {
        if (redirectTo) navigate(redirectTo);
    }, [searchParams]);

    return (
        <Wrapper>
            <Paper>
                <Title>{title}</Title>
                <Subtitle>{subtitle}</Subtitle>
                {redirectTo !== null && (
                    <Button
                        className={styles.button}
                        insideIndent={8}
                        kind='main'
                        size={isDesktop ? 'xl' : 'md'}
                        borderRadius='md'
                        onClick={handleClick}
                    >
                        {buttonText}
                    </Button>
                )}
            </Paper>
        </Wrapper>
    );
};

export default Exit;
